import { RegistrationData } from './../../core/models/registration-data.model';
import { Injectable } from '@angular/core';
import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class RegistrationStorageService {

  REGISTRATION = 'REGISTRATION/';

  private registration: RegistrationData;

  constructor(private sessionStorage: SessionStorage) {
  }

  updateRegistration(): void {
    if (!isNullOrUndefined(this.registration)) {
      this.sessionStorage.put(this.REGISTRATION, this.registration);
    }
  }

  isRegistration(): boolean {
    if (!isNullOrUndefined(this.getRegistration())) {
      return true;
    }
    return false;
  }

  createRegistration(registration: RegistrationData): void {
    this.registration = registration;

    this.updateRegistration();
  }

  setRegistration(registration: RegistrationData) {
    this.registration = registration;
  }

  getRegistration(): RegistrationData {
    return this.sessionStorage.get(this.REGISTRATION);
  }
}
